const datiFatturazioneCodiciEstero = {
    "ALBANIA": "Z100",
    "ANDORRA": "Z101",
    "AUSTRIA": "Z102",
    "BELGIO": "Z103",
    "BULGARIA": "Z104",
    "CECOSLOVACCHIA": "Z105",
    "STATO DELLA CITT\u00c0 DEL VATICANO": "Z106",
    "DANIMARCA": "Z107",
    "ISOLE F\u00c6R \u00d8ER": "Z108",
    "FINLANDIA": "Z109",
    "FRANCIA": "Z110",
    "REPUBBLICA DEMOCRATICA TEDESCA": "Z111",
    "GERMANIA": "Z112",
    "GIBILTERRA": "Z113",
    "REGNO UNITO": "Z114",
    "GRECIA": "Z115",
    "IRLANDA": "Z116",
    "ISLANDA": "Z117",
    "REPUBBLICA SOCIALISTA FEDERALE DI JUGOSLAVIA": "Z118",
    "LIECHTENSTEIN": "Z119",
    "LUSSEMBURGO": "Z120",
    "MALTA": "Z121",
    "ISOLA DI MAN": "Z122",
    "MONACO": "Z123",
    "NORVEGIA": "Z125",
    "PAESI BASSI": "Z126",
    "POLONIA": "Z127",
    "PORTOGALLO": "Z128",
    "ROMANIA": "Z129",
    "SAN MARINO": "Z130",
    "SPAGNA": "Z131",
    "SVEZIA": "Z132",
    "SVIZZERA": "Z133",
    "UNGHERIA": "Z134",
    "UNIONE SOVIETICA": "Z135",
    "UCRAINA": "Z138",
    "BIELORUSSIA": "Z139",
    "MOLDOVA": "Z140",
    "ESTONIA": "Z144",
    "LETTONIA": "Z145",
    "LITUANIA": "Z146",
    "MACEDONIA DEL NORD": "Z148",
    "CROAZIA": "Z149",
    "SLOVENIA": "Z150",
    "BOSNIA-ERZEGOVINA": "Z153",
    "FEDERAZIONE RUSSA": "Z154",
    "SLOVACCHIA": "Z155",
    "REPUBBLICA CECA": "Z156",
    "SERBIA E MONTENEGRO": "Z157",
    "SERBIA": "Z158",
    "MONTENEGRO": "Z159",
    "KOSOVO": "Z160",
    "PALESTINA": "Z161",
    "AFGHANISTAN": "Z200",
    "ARABIA SAUDITA": "Z203",
    "BAHREIN": "Z204",
    "BHUTAN": "Z205",
    "MYANMAR/BIRMANIA": "Z206",
    "BRUNEI DARUSSALAM": "Z207",
    "CAMBOGIA": "Z208",
    "SRI LANKA": "Z209",
    "CINA": "Z210",
    "CIPRO": "Z211",
    "COREA DEL SUD": "Z213",
    "COREA DEL NORD": "Z214",
    "EMIRATI ARABI UNITI": "Z215",
    "FILIPPINE": "Z216",
    "TAIWAN": "Z217",
    "GIAPPONE": "Z219",
    "GIORDANIA": "Z220",
    "INDIA": "Z222",
    "INDONESIA": "Z223",
    "IRAN": "Z224",
    "IRAQ": "Z225",
    "ISRAELE": "Z226",
    "KUWAIT": "Z227",
    "LAOS": "Z228",
    "LIBANO": "Z229",
    "MALDIVE": "Z232",
    "MONGOLIA": "Z233",
    "NEPAL": "Z234",
    "OMAN": "Z235",
    "PAKISTAN": "Z236",
    "QATAR": "Z237",
    "SIRIA": "Z240",
    "THAILANDIA": "Z241",
    "TIMOR LESTE": "Z242",
    "TURCHIA": "Z243",
    "YEMEN": "Z246",
    "MALAYSIA": "Z247",
    "SINGAPORE": "Z248",
    "BANGLADESH": "Z249",
    "YEMEN DEL SUD": "Z250",
    "VIETNAM": "Z251",
    "ARMENIA": "Z252",
    "AZERBAIGIAN": "Z253",
    "GEORGIA": "Z254",
    "KAZAKHSTAN": "Z255",
    "KIRGHIZISTAN": "Z256",
    "TAGIKISTAN": "Z257",
    "TURKMENISTAN": "Z258",
    "UZBEKISTAN": "Z259",
    "NAMIBIA": "Z300",
    "ALGERIA": "Z301",
    "ANGOLA": "Z302",
    "BURUNDI": "Z305",
    "CAMERUN": "Z306",
    "CAPO VERDE": "Z307",
    "REPUBBLICA CENTRAFRICANA": "Z308",
    "CIAD": "Z309",
    "COMORE": "Z310",
    "CONGO": "Z311",
    "REPUBBLICA DEMOCRATICA DEL CONGO": "Z312",
    "COSTA D'AVORIO": "Z313",
    "BENIN": "Z314",
    "ETIOPIA": "Z315",
    "GABON": "Z316",
    "GAMBIA": "Z317",
    "GHANA": "Z318",
    "GUINEA": "Z319",
    "GUINEA-BISSAU": "Z320",
    "GUINEA EQUATORIALE": "Z321",
    "KENYA": "Z322",
    "LIBERIA": "Z325",
    "LIBIA": "Z326",
    "MADAGASCAR": "Z327",
    "MALAWI": "Z328",
    "MALI": "Z329",
    "MAROCCO": "Z330",
    "MAURITANIA": "Z331",
    "MAURIZIO": "Z332",
    "MOZAMBICO": "Z333",
    "NIGER": "Z334",
    "NIGERIA": "Z335",
    "EGITTO": "Z336",
    "ZIMBABWE": "Z337",
    "RUANDA": "Z338",
    "SAHARA OCCIDENTALE": "Z339",
    "SANT'ELENA": "Z340",
    "SAO TOM\u00c9 E PRINCIPE": "Z341",
    "SEYCHELLES": "Z342",
    "SENEGAL": "Z343",
    "SIERRA LEONE": "Z344",
    "SOMALIA": "Z345",
    "SUDAFRICA": "Z347",
    "SUDAN": "Z348",
    "ESWATINI": "Z349",
    "TOGO": "Z351",
    "TUNISIA": "Z352",
    "UGANDA": "Z353",
    "BURKINA FASO": "Z354",
    "ZAMBIA": "Z355",
    "TANZANIA": "Z357",
    "BOTSWANA": "Z358",
    "LESOTHO": "Z359",
    "GIBUTI": "Z361",
    "ERITREA": "Z368",
    "BERMUDA": "Z400",
    "CANADA": "Z401",
    "GROENLANDIA": "Z402",
    "SAINT PIERRE E MIQUELON": "Z403",
    "STATI UNITI D'AMERICA": "Z404",
    "ARUBA": "Z501",
    "BAHAMAS": "Z502",
    "COSTA RICA": "Z503",
    "CUBA": "Z504",
    "REPUBBLICA DOMINICANA": "Z505",
    "EL SALVADOR": "Z506",
    "GIAMAICA": "Z507",
    "GUATEMALA": "Z509",
    "HAITI": "Z510",
    "HONDURAS": "Z511",
    "BELIZE": "Z512",
    "MESSICO": "Z514",
    "NICARAGUA": "Z515",
    "PANAMA": "Z516",
    "ISOLE TURKS E CAICOS": "Z519",
    "BARBADOS": "Z522",
    "GRENADA": "Z524",
    "ISOLE VERGINI BRITANNICHE": "Z525",
    "DOMINICA": "Z526",
    "SANTA LUCIA": "Z527",
    "SAINT VINCENT E GRENADINE": "Z528",
    "ANGUILLA": "Z529",
    "ISOLE CAYMAN": "Z530",
    "MONTSERRAT": "Z531",
    "ANTIGUA E BARBUDA": "Z532",
    "SAINT KITTS E NEVIS": "Z533",
    "ARGENTINA": "Z600",
    "BOLIVIA": "Z601",
    "BRASILE": "Z602",
    "CILE": "Z603",
    "COLOMBIA": "Z604",
    "ECUADOR": "Z605",
    "GUYANA": "Z606",
    "SURINAME": "Z608",
    "ISOLE FALKLAND (MALVINE)": "Z609",
    "PARAGUAY": "Z610",
    "PER\u00d9": "Z611",
    "TRINIDAD E TOBAGO": "Z612",
    "URUGUAY": "Z613",
    "VENEZUELA": "Z614",
    "AUSTRALIA": "Z700",
    "ISOLE COOK (NZ)": "Z703",
    "FIGI": "Z704",
    "ISOLE MARSHALL": "Z711",
    "NAURU": "Z713",
    "NUOVA CALEDONIA": "Z716",
    "NUOVA ZELANDA": "Z719",
    "ISOLE PITCAIRN": "Z722",
    "POLINESIA FRANCESE": "Z723",
    "ISOLE SALOMONE": "Z724",
    "SAMOA": "Z726",
    "TONGA": "Z728",
    "WALLIS E FUTUNA": "Z729",
    "PAPUA NUOVA GUINEA": "Z730",
    "KIRIBATI": "Z731",
    "TUVALU": "Z732",
    "VANUATU": "Z733",
    "PALAU": "Z734",
    "STATI FEDERATI DI MICRONESIA": "Z735",
    "SUD SUDAN": "Z907"
};